export type PlannerSlide = {
  title: string
  caption: string
  tag: string
  image: string
}

export const plannerSlides: PlannerSlide[] = [
  {
    title: 'Tu ruta',
    caption: 'Organizá ciudades, fechas y cantidad de noches.',
    tag: 'Todo centralizado',
    image: 'https://cdn.magicpatterns.com/uploads/2kp9gNfTa4UETycirSzXbs/image.png',
  },
  {
    title: 'Tus vuelos',
    caption: 'Guardá horarios, aeropuertos y datos importantes.',
    tag: 'Listo para completar',
    image: 'https://cdn.magicpatterns.com/uploads/p4jZToNAz1bco3F4fySCCq/image.png',
  },
  {
    title: 'Tus alojamientos',
    caption: 'Centralizá reservas y costos por estadía.',
    tag: 'Editable',
    image: 'https://cdn.magicpatterns.com/uploads/qTwezeuZqr2EA1PjZgikU7/image.png',
  },
  {
    title: 'Tu presupuesto',
    caption: 'Controlá lo estimado y lo realmente gastado.',
    tag: 'Cálculos automáticos',
    image: 'https://cdn.magicpatterns.com/uploads/sTjidLR2v61goT7HFYA7X1/image.png',
  },
  {
    title: 'Tu día a día',
    caption: 'Planificá actividades y reservas sin sobrecargar el itinerario.',
    tag: 'Listo para completar',
    image: 'https://cdn.magicpatterns.com/uploads/sqpQ9vG9bKCWyw86SCRJkW/image.png',
  },
  {
    title: 'Tu documentación',
    caption: 'Tené claro qué está listo y qué todavía falta resolver.',
    tag: 'Todo centralizado',
    image: 'https://cdn.magicpatterns.com/uploads/dqY6TE4yWCGp19Gz5fBrUk/image.png',
  },
]

export const plannerTags = ['Editable', 'Cálculos automáticos', 'Listo para completar', 'Todo centralizado']
